import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import menuDetailsStore from 'store/menuDetailsStore';
import { ApplicationState } from 'store';
import MenuManagementTable from 'components/menu/MenuManagementTable';
import categoryStore from 'store/categoryStore';

interface MenuDetailsProps {
    id?: string;
    close?: () => void;
    isModal?: boolean;
}

export default function MenuDetails(props: MenuDetailsProps) {
    const params: { id: string } = useParams();
    const menuDetails = useSelector((state: ApplicationState) => state.menuDetails);
    const currentPosition = useSelector(
        (state: ApplicationState) =>
            state.user.restaurants?.find((x) => x.id === state.user.currentRestaurantId)
                ?.currentPosition
    );
    const dispatch = useDispatch();

    useEffect(() => {
        // @ts-ignore
        dispatch(
            menuDetailsStore.actionCreators.getDetails(
                (params.id ? params.id : props.id)!,
                currentPosition || '',
                !props.isModal
            )
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.id, currentPosition]);


    useEffect(() => {
        dispatch(categoryStore.actionCreators.getCategoryDetails());
    }, []);

    return menuDetails.menu.name ? (
        <MenuManagementTable close={props.close} isModal={props.isModal} />
    ) : null;
}
